export default {"src":"__ASTRO_ASSET_IMAGE__C1FV$R5d__","width":1840,"height":1034,"format":"jpg"}